/* ALSU Studio — "Load more" paging for Horizon's product grids (collection + search results).
   Horizon offers either infinite scroll or numbered pagination. Direction C wants an explicit control,
   so the section is set to numbered pagination (products_per_page) and this script swaps that nav for a
   "Load more" button that appends the next page through the Section Rendering API. If the script fails
   or JavaScript is off, the numbered pagination remains as the fallback. */
(() => {
  const LABEL = 'Load more';

  const state = (list) => {
    const grid = list.querySelector('[ref="grid"]');
    const cards = grid ? [...grid.querySelectorAll(':scope > [ref="cards[]"]')] : [];
    const last = cards[cards.length - 1];
    return {
      grid,
      current: last ? Number(last.dataset.page) || 1 : 1,
      lastPage: grid ? Number(grid.dataset.lastPage) || 1 : 1,
    };
  };

  const pageUrl = (page) => {
    const url = new URL(window.location.href);
    url.searchParams.set('page', String(page));
    url.hash = '';
    return url;
  };

  const loadNext = async (list, button) => {
    const { grid, current, lastPage } = state(list);
    const next = current + 1;
    if (!grid || next > lastPage) return;
    const url = pageUrl(next);
    button.setAttribute('aria-busy', 'true');
    try {
      const fetchUrl = new URL(url);
      fetchUrl.searchParams.set('section_id', list.getAttribute('section-id'));
      const response = await fetch(fetchUrl, { headers: { Accept: 'text/html' } });
      if (!response.ok) throw new Error(`Load more: HTTP ${response.status}`);
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const cards = doc.querySelectorAll('[ref="grid"] > [ref="cards[]"]');
      if (!cards.length) throw new Error('Load more: no cards in the next page');
      grid.append(...cards);
      history.replaceState(history.state, '', url);
    } catch (error) {
      console.error(error);
      window.location.assign(url); // fall back to a full page load of the next page
      return;
    } finally {
      button.removeAttribute('aria-busy');
    }
    exhausted(list, button.parentElement);
  };

  // Hide the control once the last page is on the grid.
  const exhausted = (list, wrapper) => {
    const { current, lastPage } = state(list);
    if (current >= lastPage) wrapper.hidden = true;
  };

  const enhance = (nav) => {
    const list = nav.closest('results-list');
    if (!list) return;
    nav.dataset.alsuLoadMore = 'replaced';
    nav.hidden = true;
    const wrapper = document.createElement('div');
    wrapper.className = 'alsu-load-more-wrapper';
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'button-secondary alsu-eyebrow alsu-load-more';
    button.textContent = LABEL;
    button.addEventListener('click', () => loadNext(list, button));
    wrapper.append(button);
    nav.after(wrapper);
    exhausted(list, wrapper);
  };

  const scan = () => document.querySelectorAll('results-list .pagination:not([data-alsu-load-more])').forEach(enhance);

  // Loaded with `defer`, so the DOM is parsed. Filtering / sorting re-renders the results section
  // (nav included), so keep watching for a fresh nav.
  scan();
  new MutationObserver(scan).observe(document.body, { childList: true, subtree: true });
})();
